import { FormControl, MenuItem, Select } from "@mui/material";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import { useQuery } from "@tanstack/react-query";
import moment from "moment";
import { useState } from "react";
import { getSchedulesByDate } from "../../api/department_schedule";
import { getDoctorSummary, getDoctorsWithSchedules } from "../../api/doctors";
import { getScheduleTypes } from "../../api/schedule_types";

export default function Dashboard(props) {
  const [userId, setUserId] = useState("");
  const [scheduleTypeId, setScheduleTypeId] = useState("");

  const { data: schedules, isSuccess: isSuccessSchedules } = useQuery({
    queryKey: ["todaySchedule", moment().format("YYYY-MM-DD")],
    queryFn: () => getSchedulesByDate(moment()),
    throwOnError: true,
  });

  const { data: doctors } = useQuery({
    queryKey: ["doctors"],
    queryFn: () =>
      getDoctorsWithSchedules(
        monday,
        tuesday,
        wednesday,
        thursday,
        friday,
        satuarday,
        sunday,
      ),
    throwOnError: true,
  });

  const { data: summary } = useQuery({
    queryKey: ["summary"],
    queryFn: () => getDoctorSummary(),
    throwOnError: true,
  });

  const { data: scheduleTypes } = useQuery({
    queryKey: ["scheduleTypes"],
    queryFn: () => getScheduleTypes(),
    throwOnError: true,
  });

  const handleChangeUserId = (event) => {
    setUserId(event.target.value);
  };

  const handleChangeScheduleTypeId = (event) => {
    setScheduleTypeId(event.target.value);
  };

  const hasSchedule = (lst, id) => {
    if (!lst) {
      return false;
    }
    for (const elm of lst) {
      if (elm.schedule_type.id === id) {
        return true;
      }
    }
    return false;
  };

  const renderSchedule = (schedule, index) => (
    <Box key={index} textAlign="center">
      {schedule.schedule_type_name}
      <br />
      {schedule.start_time && schedule.end_time && (
        <>
          ({schedule.start_time}~{schedule.end_time})
        </>
      )}
    </Box>
  );

  const monday = moment().startOf("week").add(1, "days").format("yyyy年M月D日");
  const tuesday = moment()
    .startOf("week")
    .add(2, "days")
    .format("yyyy年M月D日");
  const wednesday = moment()
    .startOf("week")
    .add(3, "days")
    .format("yyyy年M月D日");
  const thursday = moment()
    .startOf("week")
    .add(4, "days")
    .format("yyyy年M月D日");
  const friday = moment().startOf("week").add(5, "days").format("yyyy年M月D日");
  const satuarday = moment()
    .startOf("week")
    .add(6, "days")
    .format("yyyy年M月D日");
  const sunday = moment().startOf("week").add(7, "days").format("yyyy年M月D日");

  const getDateOfWeedDays = (numWeek) => {
    const today = moment();
    if (today.day() === numWeek) {
      return `${today.format("yyyy/M/D")} 現在`;
    }
  };

  let byDoctorSchedule;
  if (isSuccessSchedules) {
    byDoctorSchedule = Map.groupBy(schedules, (e) => e.user.id);
  }

  return (
    <>
      <Box
        sx={{
          position: "relative;",
          width: "100%",
          height: "50%",
        }}
      >
        <TableContainer component={Paper}>
          <Box
            sx={{
              marginLeft: "12px",
              marginTop: "4px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontFamily: "Noto Sans JP",
                fontStyle: "normal",
                fontWeight: "400",
                fontSize: "24px",
                lineHeight: "133.4%",
                color: "rgba(0, 0, 0, 0.6)",
              }}
            >
              {moment().format("YYYY年M月D日")}の予定一覧
            </Typography>
          </Box>
          <Table
            sx={{ marginTop: "12px", minWidth: 300 }}
            aria-label="予定一覧"
          >
            <TableHead>
              <TableRow>
                <TableCell align="left">
                  <Box>氏名</Box>
                  <FormControl size="small">
                    <Select
                      variant="outlined"
                      sx={{ marginTop: 1, fontSize: "12px", minWidth: "150px" }}
                      labelId="user_label"
                      id="user_id"
                      name="user_id"
                      onChange={handleChangeUserId}
                      value={userId ?? ""}
                      displayEmpty
                    >
                      <MenuItem value="">選択なし</MenuItem>
                      {doctors?.map((doctor, i) => (
                        <MenuItem value={doctor.user.id} key={doctor.id}>
                          {doctor.user.full_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </TableCell>
                <TableCell align="left">
                  {moment().add(2, "months").format("M月")}の提出状況
                </TableCell>
                <TableCell align="left">
                  <Box>予定</Box>
                  <FormControl size="small">
                    <Select
                      variant="outlined"
                      sx={{ marginTop: 1, fontSize: "12px", minWidth: "150px" }}
                      labelId="schedule_type_label"
                      id="schedule_type_id"
                      name="schedule_type_id"
                      onChange={handleChangeScheduleTypeId}
                      value={scheduleTypeId ?? ""}
                      displayEmpty
                    >
                      <MenuItem value="">選択なし</MenuItem>
                      {scheduleTypes?.map((scheduleType, i) => (
                        <MenuItem value={scheduleType.id} key={scheduleType.id}>
                          {scheduleType.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </TableCell>
                <TableCell align="left">月間労働時間</TableCell>
                <TableCell align="left">年間労働時間</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {doctors
                ?.filter(
                  (row) =>
                    (userId === "" || row.user.id === userId) &&
                    (scheduleTypeId === "" ||
                      hasSchedule(
                        byDoctorSchedule?.get(row.user.id),
                        scheduleTypeId,
                      )),
                )
                .map((row) => (
                  <TableRow
                    key={row.full_name}
                    sx={{
                      backgroundColor:
                        row.confirmed === false ? "#ffcccb" : "inherit",
                      "&:last-child td, &:last-child th": { border: 0 },
                    }}
                  >
                    <TableCell component="th" scope="row">
                      {row.full_name}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {row.confirmed ? "提出済み" : "未提出"}
                    </TableCell>
                    <TableCell align="left">
                      {byDoctorSchedule?.get(row.user.id)?.map(
                        (s, i) =>
                          !s.is_negative &&
                          (scheduleTypeId === "" ||
                            s.schedule_type.id === scheduleTypeId) && (
                            <Box
                              sx={{
                                paddingTop: "1px",
                                paddingLeft: "6px",
                                marginBottom: "4px",
                                height: "21px",
                                fontSize: "13px",
                                background: s.is_negative
                                  ? "#707070"
                                  : s.schedule_type.bg_color,
                                outlineWidth: s.is_settled ? 2 : 0,
                                outlineStyle: s.is_settled ? "solid" : "none",
                                borderRadius: "4px",
                                overflow: "hidden",
                              }}
                              key={s.id}
                            >
                              <Typography
                                component="span"
                                sx={{
                                  fontSize: "13px",
                                  fontWeight:
                                    s.source === 1 ? "normal" : "bold",
                                  color: s.is_negative
                                    ? "white"
                                    : (s.schedule_type.fg_color ?? "#763833"),
                                }}
                              >
                                {s.start_time?.substring(0, 5)}&nbsp;~&nbsp;
                                {s.end_time?.substring(0, 5)}&nbsp;&nbsp;
                                {s.schedule_type.name}
                              </Typography>
                            </Box>
                          ),
                      )}
                    </TableCell>
                    <TableCell align="left">
                      {summary?.monthly?.[row.id] ?? 0}
                    </TableCell>
                    <TableCell align="left">
                      {summary?.yearly?.[row.id] ?? 0}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      {/* 以下より「週間基本予定表」 */}
      <Box
        sx={{
          marginLeft: "12px",
          marginTop: "4px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontFamily: "Noto Sans JP",
            fontStyle: "normal",
            fontWeight: "400",
            fontSize: "24px",
            lineHeight: "133.4%",
            color: "rgba(0, 0, 0, 0.6)",
          }}
        >
          {monday}~{sunday}の週間基本予定表
        </Typography>
      </Box>

      <Box>
        <Table
          sx={{
            display: "block",
            marginTop: "12px",
            overflow: "scroll",
            border: "1px solid rgba(224, 224, 224, 1)",
            "& .MuiTableCell-root": {
              border: "1px solid rgba(224, 224, 224, 1)",
            },
          }}
          aria-label="週間基本予定表"
        >
          <TableHead>
            <TableRow>
              <TableCell
                align="center"
                rowSpan={2}
                sx={{
                  color: "#FFFFFF",
                  background: "#808080",
                  minWidth: "150px",
                }}
              >
                <Box>役職</Box>
              </TableCell>
              <TableCell
                align="center"
                rowSpan={2}
                sx={{
                  color: "#FFFFFF",
                  background: "#808080",
                  minWidth: "150px",
                }}
              >
                氏名
              </TableCell>
              <TableCell
                align="center"
                rowSpan={2}
                sx={{ color: "#FFFFFF", background: "#808080" }}
              >
                <Box>PHS</Box>
              </TableCell>
              <TableCell
                align="center"
                colSpan={2}
                sx={{ color: "#FFFFFF", background: "#FF8856" }}
              >
                <Box>{monday}(月)</Box>
              </TableCell>
              <TableCell
                align="center"
                colSpan={2}
                sx={{ color: "#FFFFFF", background: "#75A9FF" }}
              >
                <Box>{tuesday}(火)</Box>
              </TableCell>
              <TableCell
                align="center"
                colSpan={2}
                sx={{ color: "#FFFFFF", background: "#FF8856" }}
              >
                <Box>{wednesday}(水)</Box>
              </TableCell>
              <TableCell
                align="center"
                colSpan={2}
                sx={{ color: "#FFFFFF", background: "#75A9FF" }}
              >
                <Box>{thursday}(木)</Box>
              </TableCell>
              <TableCell
                align="center"
                colSpan={2}
                sx={{ color: "#FFFFFF", background: "#FF8856" }}
              >
                <Box>{friday}(金)</Box>
              </TableCell>
              <TableCell
                align="center"
                colSpan={2}
                sx={{ color: "#FFFFFF", background: "#75A9FF" }}
              >
                <Box>{satuarday}(土)</Box>
              </TableCell>
              <TableCell
                align="center"
                colSpan={2}
                sx={{ color: "#FFFFFF", background: "#FF8856" }}
              >
                <Box>{sunday}(日)</Box>
              </TableCell>
            </TableRow>
            <TableRow>
              {/* ここから月曜分 */}
              <TableCell
                align="center"
                sx={{ background: "#FFAD90", minWidth: "200px" }}
              >
                午前
              </TableCell>
              <TableCell
                align="center"
                sx={{ background: "#FFDBC9", minWidth: "200px" }}
              >
                午後
              </TableCell>
              {/* ここまで月曜分 */}
              {/* ここから火曜分 */}
              <TableCell
                align="center"
                sx={{ background: "#A4C6FF", minWidth: "200px" }}
              >
                午前
              </TableCell>
              <TableCell
                align="center"
                sx={{ background: "#D9E5FF", minWidth: "200px" }}
              >
                午後
              </TableCell>
              {/* ここまで火曜分 */}
              {/* ここから水曜分 */}
              <TableCell
                align="center"
                sx={{ background: "#FFAD90", minWidth: "200px" }}
              >
                午前
              </TableCell>
              <TableCell
                align="center"
                sx={{ background: "#FFDBC9", minWidth: "200px" }}
              >
                午後
              </TableCell>
              {/* ここまで水曜分 */}
              {/* ここから木曜分 */}
              <TableCell
                align="center"
                sx={{ background: "#A4C6FF", minWidth: "200px" }}
              >
                午前
              </TableCell>
              <TableCell
                align="center"
                sx={{ background: "#D9E5FF", minWidth: "200px" }}
              >
                午後
              </TableCell>
              {/* ここまで木曜分 */}
              {/* ここから金曜分 */}
              <TableCell
                align="center"
                sx={{ background: "#FFAD90", minWidth: "200px" }}
              >
                午前
              </TableCell>
              <TableCell
                align="center"
                sx={{ background: "#FFDBC9", minWidth: "200px" }}
              >
                午後
              </TableCell>
              {/* ここまで金曜分 */}
              {/* ここから土曜分 */}
              <TableCell
                align="center"
                sx={{ background: "#A4C6FF", minWidth: "200px" }}
              >
                午前
              </TableCell>
              <TableCell
                align="center"
                sx={{ background: "#D9E5FF", minWidth: "200px" }}
              >
                午後
              </TableCell>
              {/* ここまで土曜分 */}
              {/* ここから日曜分 */}
              <TableCell
                align="center"
                sx={{ background: "#FFAD90", minWidth: "200px" }}
              >
                午前
              </TableCell>
              <TableCell
                align="center"
                sx={{ background: "#FFDBC9", minWidth: "200px" }}
              >
                午後
              </TableCell>
              {/* ここまで日曜分 */}
            </TableRow>
          </TableHead>
          <TableBody>
            {doctors
              ?.filter(
                (row) =>
                  (userId === "" || row.user.id === userId) &&
                  (scheduleTypeId === "" ||
                    hasSchedule(
                      byDoctorSchedule?.get(row.user.id),
                      scheduleTypeId,
                    )),
              )
              .map((row) => (
                <TableRow key={row.full_name}>
                  <TableCell align="center" component="th" scope="row">
                    {row.doctor_type_name}
                  </TableCell>
                  <TableCell align="center" component="th" scope="row">
                    {row.full_name}
                  </TableCell>
                  <TableCell align="center">{row.phs}</TableCell>
                  <TableCell align="center">
                    {row.schedule_monday_morning.map((schedule, index) =>
                      renderSchedule(schedule, index),
                    )}
                  </TableCell>
                  <TableCell align="center">
                    {row.schedule_monday_afternoon.map((schedule, index) =>
                      renderSchedule(schedule, index),
                    )}
                  </TableCell>
                  <TableCell align="center">
                    {row.schedule_tuesday_morning.map((schedule, index) =>
                      renderSchedule(schedule, index),
                    )}
                  </TableCell>
                  <TableCell align="center">
                    {row.schedule_tuesday_afternoon.map((schedule, index) =>
                      renderSchedule(schedule, index),
                    )}
                  </TableCell>
                  <TableCell align="center">
                    {row.schedule_wednesday_morning.map((schedule, index) =>
                      renderSchedule(schedule, index),
                    )}
                  </TableCell>
                  <TableCell align="center">
                    {row.schedule_wednesday_afternoon.map((schedule, index) =>
                      renderSchedule(schedule, index),
                    )}
                  </TableCell>
                  <TableCell align="center">
                    {row.schedule_thursday_morning.map((schedule, index) =>
                      renderSchedule(schedule, index),
                    )}
                  </TableCell>
                  <TableCell align="center">
                    {row.schedule_thursday_afternoon.map((schedule, index) =>
                      renderSchedule(schedule, index),
                    )}
                  </TableCell>
                  <TableCell align="center">
                    {row.schedule_friday_morning.map((schedule, index) =>
                      renderSchedule(schedule, index),
                    )}
                  </TableCell>
                  <TableCell align="center">
                    {row.schedule_friday_afternoon.map((schedule, index) =>
                      renderSchedule(schedule, index),
                    )}
                  </TableCell>
                  <TableCell align="center">
                    {row.schedule_saturday_morning.map((schedule, index) =>
                      renderSchedule(schedule, index),
                    )}
                  </TableCell>
                  <TableCell align="center">
                    {row.schedule_saturday_afternoon.map((schedule, index) =>
                      renderSchedule(schedule, index),
                    )}
                  </TableCell>
                  <TableCell align="center">
                    {row.schedule_sunday_morning.map((schedule, index) =>
                      renderSchedule(schedule, index),
                    )}
                  </TableCell>
                  <TableCell align="center">
                    {row.schedule_sunday_afternoon.map((schedule, index) =>
                      renderSchedule(schedule, index),
                    )}
                  </TableCell>
                </TableRow>
              ))}
            <TableRow>
              <TableCell sx={{ background: "#808080" }} />
              <TableCell sx={{ background: "#808080" }} />
              <TableCell sx={{ background: "#808080" }} />
              <TableCell align="center" colSpan={2} sx={{ color: "blue" }}>
                {getDateOfWeedDays(1)}
              </TableCell>
              <TableCell align="center" colSpan={2} sx={{ color: "blue" }}>
                {getDateOfWeedDays(2)}
              </TableCell>
              <TableCell align="center" colSpan={2} sx={{ color: "blue" }}>
                {getDateOfWeedDays(3)}
              </TableCell>
              <TableCell align="center" colSpan={2} sx={{ color: "blue" }}>
                {getDateOfWeedDays(4)}
              </TableCell>
              <TableCell align="center" colSpan={2} sx={{ color: "blue" }}>
                {getDateOfWeedDays(5)}
              </TableCell>
              <TableCell align="center" colSpan={2} sx={{ color: "blue" }}>
                {getDateOfWeedDays(6)}
              </TableCell>
              <TableCell align="center" colSpan={2} sx={{ color: "blue" }}>
                {getDateOfWeedDays(7)}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Box>
    </>
  );
}
